import { render } from "./Electro3Contact.vue?vue&type=template&id=09cf2b72&scoped=true"
import script from "./Electro3Contact.vue?vue&type=script&lang=js"
export * from "./Electro3Contact.vue?vue&type=script&lang=js"

import "./Electro3Contact.vue?vue&type=style&index=0&id=09cf2b72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cf2b72"]])

export default __exports__